// @ts-nocheck
import React, { useState } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import GameResult from './GameResult';
import { useTranslation } from 'react-i18next';

export interface SearchProps {
  games?: unknown[];
  onSelect: (value: unknown) => void;
  disabled?: boolean;
}

function Search({ games, onSelect, disabled }: SearchProps) {
  const { t } = useTranslation();
  const [selected, setSelected] = useState([]);
  return (
    <Typeahead
      id="game-search"
      placeholder={t('Start typing a game name..')}
      labelKey="name"
      minLength={3}
      onChange={(options) => {
        onSelect(options);
        setSelected([]);
      }}
      selected={selected}
      renderMenuItemChildren={(option, props) => (
        <GameResult {...option}></GameResult>
      )}
      options={games || []}
      disabled={disabled}
    />
  );
}

export default Search;
